<template>
  <div>
    <Table />
  </div>
</template>

<script>
import Table from '@/view/pages/report/Table'
export default {
  name: 'daily_report',
  components: {
    Table,
  },
}
</script>

<style lang="scss" scoped></style>
